import { render, staticRenderFns } from "./designify_cta.vue?vue&type=template&id=9ce680dc&scoped=true&"
import script from "./designify_cta.vue?vue&type=script&lang=js&"
export * from "./designify_cta.vue?vue&type=script&lang=js&"
import style0 from "./designify_cta.vue?vue&type=style&index=0&id=9ce680dc&lang=scss&scoped=true&"
import style1 from "./designify_cta.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce680dc",
  null
  
)

export default component.exports